import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Component, Input, Output } from '@angular/core';
import _get from 'lodash/get';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
})
export class ChipsComponent implements OnChanges {
  @Input() item: any = null;
  @Input() key: any = '';
  @Input() removable = false;
  @Output() removeItem: EventEmitter<any> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    this.item = _get(changes, 'item.currentValue', {});
  }

  remove() {
    this.removeItem.emit(JSON.stringify(this.item));
  }
}
